import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CropStringPipeModule } from '@shared/pipes/crop-string-pipe/crop-string.pipe.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SpinnerModule } from '@shared/spinner/spinner.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AlertModule } from 'ngx-bootstrap/alert';
import { FilterCurrentOrganizationsPipe } from '@modules/in-app-notifications/alerts/filter-current-organizations.pipe';
import { AlertsComponent } from '@modules/in-app-notifications/alerts/alerts.component';
import { FormsModule } from '@angular/forms';

@NgModule({
	declarations: [FilterCurrentOrganizationsPipe, AlertsComponent],
	exports: [AlertsComponent],
	imports: [
		MatCheckboxModule,
		CropStringPipeModule,
		MatTooltipModule,
		SpinnerModule,
		CommonModule,
		BsDropdownModule,
		AlertModule,
		FormsModule,
	],
})
export class InAppNotificationsModule {}
